import { Button, Grid, Typography } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import React, { Fragment, useState, useEffect } from 'react';
import Breadcrumbs from '../core/controls/components/breadcrumbs';
import YearDropdown from './YearDropdown';
import { DownloadallInvoice } from '../core/controls/components/custom/downloadshelper';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import TextBox from '../core/controls/components/textbox';
import { getEnvVariable } from '../modules/environmentalList.js';
import { GetData } from '../core/controls/helpers/requests';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';

const breadcrumbs = {
    type: 'breadcrumbs',
    items: [
        { "link": "Download Renewal Invoices", href: "/Administration/invoicemanagementtabs", "materialicon": "file_download", className: 'breadcrumb-item ', class: '' }
    ],
};

export default function DownloadAllInvoices() {
    const [year, setyear] = useState(2025);
    const [radiovalue, setradiovalue] = useState('Unpaid');
    const [emailvalue, setemailvalue] = useState('No');
    const [applicants, setApplicants] = useState([]);
    const [selectedApplicant, setSelectedApplicant] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        getownernames();
    }, []);

    const handleYearSelect = (year) => {
        setyear(year);
    };

    const download = () => {
        // Include selectedApplicant in the download parameters
        const applicantId = selectedApplicant ? selectedApplicant.id : 0;
        DownloadallInvoice(year, radiovalue, emailvalue, applicantId, true).then(res => {
            const downloadLink = document.createElement("a");
            downloadLink.href = res.base64PDFFileContent;
            downloadLink.download = res.fileName;
            downloadLink.click();
            downloadLink.remove();
        });
    };

    const handleRadioChange = (event) => {
        setradiovalue(event.target.value);
    };

    const handleEmailRadioChange = (event) => {
        setemailvalue(event.target.value);
    };

    const getownernames = () => {
        setIsLoading(true);
        let url = getEnvVariable('Payment') + `InvoiceDashboard/All`;

        GetData(url, '', true).then(resp => {
            if (resp && resp.length > 0) {
                const uniqueApplicants = Array.from(new Set(
                    resp.map(item => JSON.stringify({ id: item.ApplicantId, name: item.Applicant }))
                )).map(item => JSON.parse(item));
                
                setApplicants(uniqueApplicants);
            }
            setIsLoading(false);
        }).catch(err => {
            console.error("Error fetching applicant data:", err);
            setIsLoading(false);
        });
    }

    const handleApplicantChange = (event, newValue) => {
        setSelectedApplicant(newValue);
    };

    return (
        <Fragment>
            <div className="d-flex application-border my-2 p-0">
                <Breadcrumbs {...breadcrumbs} className="pt-2" />
            </div>
            <div className="application-border mb-1">
                <Card>
                    <CardActions>
                        <Grid container spacing={3}>
                            {/* GROUP 1: Year Selection - Always Applied */}
                            <Grid item xs={12}>
                                <Card variant="outlined" className="p-2">
                                    <Typography variant="subtitle1" gutterBottom style={{ fontWeight: 600, color: '#3f51b5' }}>
                                        Select Billing Year (Always Applied)
                                    </Typography>
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item xs={12} sm={2}>
                                            <Typography variant="body1" style={{ fontWeight: 600 }}>Year:</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={10}>
                                            <YearDropdown className="billingyear" onSelect={handleYearSelect} name="YEAR" />
                                        </Grid>
                                    </Grid>
                                </Card>
                            </Grid>
    
                            {/* Filter Method Selection Notice */}
                            <Grid item xs={12}>
                                <Typography variant="subtitle1" style={{ fontWeight: 600, color: '#f44336' }}>
                                    Please select one filtering method:
                                </Typography>
                                <Typography variant="body2" style={{ marginBottom: '4px' }}>
                                    • If you select an <b>Applicant Name</b>, invoices will be downloaded only for that applicant.
                                </Typography>
                                <Typography variant="body2">
                                    • If <b>Applicant Name</b> is empty, the system will apply the <b>Payment Status</b> and <b>Email Sent</b> filters across all owners.
                                </Typography>
                            </Grid>
                            
                            {/* GROUP 2: General Filters (applied when no specific owner/applicant) */}
                            <Grid item xs={12}>
                                <Card variant="outlined" className="p-2" style={{ 
                                    borderColor: (selectedApplicant) ? '#e0e0e0' : '#4caf50',
                                    backgroundColor: (selectedApplicant) ? '#f5f5f5' : 'white',
                                    opacity: (selectedApplicant) ? 0.8 : 1
                                }}>
                                    <Typography variant="subtitle1" gutterBottom style={{ 
                                        fontWeight: 600, 
                                        color: (selectedApplicant) ? '#9e9e9e' : '#3f51b5'
                                    }}>
                                        Filter Options
                                    </Typography>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="body1" style={{ fontWeight: 600 }}>Payment Status:</Typography>
                                            <RadioGroup
                                                aria-label="actions"
                                                name="actions"
                                                value={radiovalue || 'Unpaid'}
                                                onChange={handleRadioChange}
                                                row
                                                disabled={!!selectedApplicant}
                                            >
                                                <FormControlLabel 
                                                    value="Paid" 
                                                    control={<Radio disabled={!!selectedApplicant} />} 
                                                    label="Paid" 
                                                />
                                                <FormControlLabel 
                                                    value="Unpaid" 
                                                    control={<Radio disabled={!!selectedApplicant} />} 
                                                    label="Unpaid" 
                                                />
                                            </RadioGroup>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="body1" style={{ fontWeight: 600 }}>Email Sent:</Typography>
                                            <RadioGroup
                                                aria-label="actions"
                                                name="actions"
                                                value={emailvalue || 'No'}
                                                onChange={handleEmailRadioChange}
                                                row
                                            >
                                                <FormControlLabel 
                                                    value="Yes" 
                                                    control={<Radio disabled={!!selectedApplicant} />} 
                                                    label="Yes" 
                                                />
                                                <FormControlLabel 
                                                    value="No" 
                                                    control={<Radio disabled={!!selectedApplicant} />} 
                                                    label="No" 
                                                />
                                            </RadioGroup>
                                        </Grid>
                                    </Grid>
                                </Card>
                            </Grid>
        
                            {/* GROUP 3: Specific Filters - Owner ID or Applicant */}
                            <Grid item xs={12}>
                                <Card variant="outlined" className="p-2">
                                    <Typography variant="subtitle1" gutterBottom style={{ fontWeight: 600, color: '#3f51b5' }}>
                                        Filter by Specific Applicant Name
                                    </Typography>                                 
                                        {/* Applicant Name */}
                                        <Grid item xs={12} sm={6}>
                                            <Card variant="outlined" className="p-2" style={{ 
                                                borderColor: selectedApplicant ? '#4caf50' : '#e0e0e0',
                                                height: '100%'
                                            }}>
                                                <Typography variant="body1" style={{ fontWeight: 600 }}>Applicant Name:</Typography>
                                                <Autocomplete
                                                    id="applicant-select"
                                                    options={applicants}
                                                    loading={isLoading}
                                                    getOptionLabel={(option) => option.name || ""}
                                                    value={selectedApplicant}
                                                    onChange={handleApplicantChange}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Select Applicant"
                                                            variant="outlined"
                                                            margin="normal"
                                                            placeholder="Type to search applicants"
                                                            fullWidth
                                                        />
                                                    )}
                                                />
                                            </Card>
                                        </Grid>                           
                                </Card>
                            </Grid>
        
                            {/* Download Button */}
                            <Grid item xs={12} style={{ textAlign: 'right', marginTop: '16px' }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={download}
                                    size="large"
                                >
                                    Download Invoices
                                </Button>
                            </Grid>
                        </Grid>
                    </CardActions>
                </Card>
            </div>
        </Fragment>
    );
}